/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { Select, Option, asField } from "informed";
import { isEqual as _isEqual } from "lodash";

import validatehoc from "../Validator";

class SelectInput extends Component {
	constructor(props) {
		super(props);
		let groups = [];
		let groupObj = {};
		props.values.forEach(option => {
			if (option.group) {
				groupObj[option.group] = option.group;
			}
		});
		Object.keys(groupObj).forEach(group => {
			groups.push(group);
		});
		this.state = {
			minimizePlaceholder: false,
			groups,
		};
	}

	componentDidMount() {
		const { values, fieldApi, placeholder, initialValue } = this.props;
		if (initialValue) {
			let found = false;
			let first = null;
			values.forEach(option => {
				if (!option.group) {
					if (!first) {
						first = option;
					}
					if (initialValue === option.value) {
						found = true;
					}
				}
			});
			if (!found) {
				let newValue = "";
				if (!placeholder && first) {
					newValue = first.value;
				}
				setTimeout(() => {
					fieldApi.setValue(newValue);
				}, 50);
			}
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let groups = [];
		let groupObj = {};
		nextProps.values.forEach(option => {
			if (option && option.group) {
				groupObj[option.group] = option.group;
			}
		});
		Object.keys(groupObj).forEach(group => {
			groups.push(group);
		});
		if (!_isEqual(prevState.groups, groups)) {
			return { groups };
		}
		return null;
	}

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	onBlur = value => {
		if (!value || value.length < 1) {
			this.setState({
				minimizePlaceholder: false,
			});
		}
	};

	render() {
		const { autocomplete, field, id, fieldState, onChange, helperText } = this.props;
		var inputProps = {
			field: field,
			id: id,
			...(autocomplete ? { autocomplete: autocomplete } : {}),
			...(onChange ? { onChange } : {}),
		};

		let override = false;
		const { value, error } = fieldState;
		const { minimizePlaceholder } = this.state;
		const { placeholder, values, isRequired } = this.props;
		const hasError = error ? " has-error" : "";

		if (value && value.length > 0 && minimizePlaceholder === false) {
			override = true;
		}
		const isFocused = minimizePlaceholder || override ? " focus" : "";

		let options;

		if (this.state.groups.length > 0) {
			options = this.state.groups.map(group => (
				<optgroup key={group} label={group}>
					{values
						.map(value => {
							if (value.group && value.group === group) {
								return (
									<Option key={value.value} value={value.value}>
										{value.label}
									</Option>
								);
							} else {
								return null;
							}
						})
						.filter(e => e != null)}
				</optgroup>
			));
		} else {
			options = values.map(value => (
				<Option key={value.key} value={value.value}>
					{value.label}
				</Option>
			));
		}

		return (
			<Fragment>
				<div className={`select-wrap${isFocused}${hasError}`}>
					<div className="select-box-wrapper">
						<div className="placeholder">
							<span className={isFocused ? "caption-text" : ""}>
								{isRequired && <span className="isrequired-label">*</span>}
								{placeholder}
							</span>
						</div>
						<div className="select-box">
							<div className="select-arrow">
								<i className="fal fa-chevron-down"></i>
							</div>
							<Select className={hasError} {...inputProps}>
								{placeholder && <Option value="" disabled={!this.props.defaultEnabled}></Option>}
								{options}
							</Select>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<div className="caption-text helper-message">{helperText}</div>
						</div>
						{error && <div className="error-message caption-text">{error}</div>}
					</div>
				</div>
			</Fragment>
		);
	}
}

SelectInput.propTypes = {
	autocomplete: PropTypes.string,
	defaultEnabled: PropTypes.bool,
	field: PropTypes.string,
	fieldApi: PropTypes.object,
	fieldState: PropTypes.object,
	helperText: PropTypes.string,
	id: PropTypes.string,
	initialValue: PropTypes.string,
	isRequired: PropTypes.bool,
	maxLength: PropTypes.number,
	minLength: PropTypes.number,
	placeholder: PropTypes.string,
	onChange: PropTypes.func,
	regexMessage: PropTypes.string,
	validationRegex: PropTypes.string,
	values: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			value: PropTypes.string,
			label: PropTypes.string,
		})
	),
};

const Wrapper = validatehoc(asField(({ fieldState, ...props }) => <SelectInput fieldState={fieldState} {...props} />));

export default Wrapper;
